export default __webpack_public_path__ + "static/media/backupFile.0724637b.svg";